(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const instances = new WeakMap();

  function proof(root) {
    if (instances.has(root)) return;
    const steps = [...root.querySelectorAll('[data-proof-step]')];
    const frames = [...root.querySelectorAll('[data-proof-frame]')];
    if (!steps.length || steps.length !== frames.length || !('IntersectionObserver' in window)) return;
    let observer;
    const visible = new Map();
    function select(index) {
      frames.forEach((frame, i) => frame.classList.toggle('is-active', i === index));
      steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
    }
    function configure() {
      observer?.disconnect();
      visible.clear();
      const enhance = desktop.matches && !motion.matches && !window.Shopify?.designMode;
      root.classList.toggle('is-enhanced', enhance);
      if (!enhance) return;
      select(0);
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
        const candidates = steps.filter(step => visible.get(step));
        if (candidates.length) {
          const center = window.innerHeight * 0.52;
          const distance = step => {
            const rect = step.getBoundingClientRect();
            return Math.abs((rect.top + rect.bottom) / 2 - center);
          };
          const active = candidates.reduce((a, b) => distance(a) < distance(b) ? a : b);
          select(steps.indexOf(active));
        }
      }, {rootMargin: '-20% 0px -20% 0px', threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]});
      steps.forEach(step => observer.observe(step));
    }
    configure();
    desktop.addEventListener('change', configure);
    motion.addEventListener('change', configure);
    instances.set(root, () => {
      observer?.disconnect();
      desktop.removeEventListener('change', configure);
      motion.removeEventListener('change', configure);
    });
  }

  function purchaseBar(root) {
    if (instances.has(root) || !('IntersectionObserver' in window)) return;
    const info = document.getElementById(root.dataset.productInfo);
    const purchase = info?.querySelector('.product-form__buttons');
    if (!info || !purchase) return;
    const variant = root.querySelector('[data-bar-variant]');
    const price = root.querySelector('[data-bar-price]');
    const action = root.querySelector('a');
    function sync() {
      const nativePrice = info.querySelector('[id^="price-"] .price');
      if (price && nativePrice) price.innerHTML = nativePrice.innerHTML;
      const values = [...info.querySelectorAll('variant-selects input:checked, variant-selects select')].map(input => input.value);
      variant.textContent = values.join(' / ');
    }
    let visibilityFrame = 0;
    const updateVisibility = () => {root.hidden = purchase.getBoundingClientRect().bottom >= 0;};
    const scheduleVisibility = () => {
      if (visibilityFrame) return;
      visibilityFrame = window.requestAnimationFrame(() => {visibilityFrame = 0;updateVisibility();});
    };
    const observer = new IntersectionObserver(updateVisibility, {threshold: 0});
    const mutation = new MutationObserver(sync);
    mutation.observe(info, {childList: true, subtree: true});
    info.addEventListener('change', sync);
    const navigate = event => {
      event.preventDefault();
      const target = info.querySelector('variant-selects fieldset, variant-selects select, .product-form__buttons') || info;
      target.setAttribute('tabindex', '-1');
      target.scrollIntoView({block: 'center', behavior: 'auto'});
      target.focus({preventScroll: true});
      updateVisibility();
    };
    action.addEventListener('click', navigate);
    observer.observe(purchase);
    window.addEventListener('scroll', scheduleVisibility, {passive: true});
    window.addEventListener('resize', scheduleVisibility, {passive: true});
    updateVisibility();
    sync();
    instances.set(root, () => {observer.disconnect(); mutation.disconnect(); info.removeEventListener('change', sync); action.removeEventListener('click', navigate);window.removeEventListener('scroll', scheduleVisibility);window.removeEventListener('resize', scheduleVisibility);window.cancelAnimationFrame(visibilityFrame);});
  }

  function article(root) {
    if (instances.has(root)) return;
    const body = root.querySelector('[itemprop="articleBody"]');
    const toc = root.querySelector('[data-article-toc]');
    if (!body || !toc) return;
    const headings = [...body.querySelectorAll('h2')].filter(el => el.textContent.trim());
    if (headings.length < 3) return;
    const list = toc.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = `forge-article-heading-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      heading.classList.add('forge-anchor');
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      li.append(link);list.append(li);
    });
    toc.hidden = false;
    instances.set(root, () => {});
  }

  function media(root) {
    if (instances.has(root)) return;
    const video = root.querySelector('video');
    const button = root.querySelector('[data-video-toggle]');
    if (!video || !button) return;
    video.autoplay = false;
    video.loop = false;
    const update = () => {
      button.textContent = video.paused ? button.dataset.play : button.dataset.pause;
      button.setAttribute('aria-pressed', String(!video.paused));
    };
    const toggle = () => {if (video.paused) video.play().catch(update);else video.pause();};
    const reduce = () => {if (motion.matches) video.pause();};
    const visibility = () => {if (document.hidden) video.pause();};
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {if (!entries[0].isIntersecting) video.pause();}) : null;
    observer?.observe(video);
    button.addEventListener('click', toggle);
    video.addEventListener('play', update);video.addEventListener('pause', update);video.addEventListener('ended', update);
    document.addEventListener('visibilitychange', visibility);
    motion.addEventListener('change', reduce);
    update();
    button.hidden = false;
    instances.set(root, () => {observer?.disconnect();video.pause();button.removeEventListener('click', toggle);video.removeEventListener('play', update);video.removeEventListener('pause', update);video.removeEventListener('ended', update);document.removeEventListener('visibilitychange', visibility);motion.removeEventListener('change', reduce);});
  }

  function table(wrapper) {
    if (instances.has(wrapper) || !('ResizeObserver' in window)) return;
    const head = document.querySelector('[data-table-cue]');
    if (!head) return;
    const cue = document.createElement('p');
    cue.className = 'forge-table-cue';cue.textContent = head.dataset.tableCue;cue.hidden = true;
    wrapper.before(cue);
    const update = () => {
      const overflow = wrapper.clientWidth > 0 && wrapper.scrollWidth > wrapper.clientWidth + 1;
      cue.hidden = !overflow;
      if (overflow) {
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', head.dataset.tableLabel);
      } else {
        wrapper.removeAttribute('tabindex');wrapper.removeAttribute('role');wrapper.removeAttribute('aria-label');
      }
    };
    const observer = new ResizeObserver(update);observer.observe(wrapper);
    const mutation = new MutationObserver(update);mutation.observe(wrapper, {childList: true, subtree: true});
    update();
    instances.set(wrapper, () => {observer.disconnect();mutation.disconnect();cue.remove();});
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-forge-proof]').forEach(proof);
    scope.querySelectorAll('[data-forge-purchase-bar]').forEach(purchaseBar);
    scope.querySelectorAll('[data-forge-article]').forEach(article);
    scope.querySelectorAll('[data-forge-media]').forEach(media);
    scope.querySelectorAll('.lpl-table-wrap, .lpb-table-wrap').forEach(table);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-forge-proof], [data-forge-purchase-bar], [data-forge-article], [data-forge-media], .lpl-table-wrap, .lpb-table-wrap').forEach(element => {instances.get(element)?.();instances.delete(element);});
  });
})();
